import type { FC } from "react";

import { HeaderBlock as UIHeaderBlock } from "@jti/loyalty/components/HeaderBlock";

import type { headerBlockInputs } from "./HeaderBlock.builder";

export type HeaderBlockBuilderProps = BuilderComponentProps<typeof headerBlockInputs>;

export const HeaderBlock: FC<HeaderBlockBuilderProps> = (props) => {
  return <UIHeaderBlock {...props} />;
};
